<div class="d-lg-flex header border align-item-center justify-content-between">

    <div class="header-logo col-md-2 d-none d-lg-block px-3">
      <img src="./newLogo.svg" style="margin-top:6px;    max-width: 100%; border-radius: 0.1875rem;">
    </div>
    <div class="col-lg-10 col-sm-12 row justify-content-between headerTitle py-3">
        <div class="col-lg-7 col-8  ms-lg-0 row ">
            <p class=" col-lg-6 pd d-none d-lg-block"> {{ headerTitle }}</p>
            <div (click)="onToggleSidebar()" class="d-lg-none col-1 ms-4 me-2 fs-4"><i class="fa fa-bars" aria-hidden="true"></i></div>
        </div>
        <div class="col-4  col-lg-3 d-flex justify-content-end align-items-center">
            <div class="d-flex pe-lg-4 ">
                <!-- start notification -->
                <span   style="cursor: pointer; margin-right: 1.25rem;margin-top:0.55rem; position: relative;" (click)="toggleDropdown()">
                  
                   <i   class="pi pi-bell"   badgeClass="p-badge-white"  style="font-size: 1.5rem; " ></i>   


                     <span *ngIf="unreadCount > 0" class="badge">
                        {{ unreadCount }}
                    </span>

                    <!-- Dropdown -->
    <div class="dropdown-panel" *ngIf="showDropdown">
      <div class="dropdown-header">
        Notifications
        <span class="count">({{ notifications.length }})</span>
      </div>

      <div *ngIf="notifications.length === 0" class="dropdown-empty">
        No notifications
      </div>

      <div *ngIf="notifications.length > 0" class="dropdown-list">
        <div
          class="notification-item"
          *ngFor="let n of notifications"
          (click)="onClickNotification(n)">
          <img src="/notify.svg">
           <div>
            <div class="title">{{ n.title }}</div>
          <div class="message">{{ n.message }}</div>
          <div class="time">
            {{ n.created_At | date:'short' }}
          </div>
           </div>
        </div>
      </div>
    </div>
  


                </span>
               
                  <div class="d-flex" style="margin-left: 1rem; margin-right: 1rem; cursor: pointer; display: flex; justify-content: center; align-items: center; gap:5px;"   >
                    <!-- <div class=" me-1"><img src="./One.svg" /></div> -->
                    <div style=" width: 33px; height: 33px; padding: 6px; border-radius: 50%; background-color: #FFB900; text-align: center; display: flex; justify-content: center; align-items: center; ">{{ initials }}</div>
                    <div class="pname"  >{{ firstName }}</div>
                </div>
            </div>

        </div>
    </div>

</div>

